<template>
  <div class="slsdgc">

    <div class="calc-templete">
      <h6>勘察费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" labelWidth="195px">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>水利水电工程勘察费</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{ fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>

            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称" style="width: 320px;"></t-input>
            </t-form-item>

            <t-form-item label="工程造价" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入工程造价" style="width: 320px;" suffix="万元"
                type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>
            <t-form-item name="scheduleProportion" class="form-item-left">
              <span slot="label">

                比例表
              </span>
              <t-input v-model="scheduleProportion" placeholder="请输入比例" suffix="%" style="width: 320px;"></t-input>
              <!-- <t-cascader class="custom-cascader-1" v-model="formData.domainCoefficient" :options="domainCoefficientList" clearable key="id" @change="changedomainCoefficient" :keys="{ value: 'id',label: 'label',children: 'children'}" ></t-cascader> -->
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible4">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item name="adjustmentCoefficient" class="form-item-left">
              <span slot="label">

                专业调整
              </span>
              <t-input v-model="formData.adjustmentCoefficient" placeholder="请输入专业调整系数" style="width: 320px;"></t-input>

              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible1">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item name="scoreAssignmentTable" class="form-item-left">
              <span slot="label">

                赋分表
              </span>
              <t-input v-model="formData.scoreAssignmentTable" placeholder="" style="width: 320px;"></t-input>

              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible5">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item class="form-item-left">
              <span slot="label">

                复杂程度
              </span>
              <t-input v-model="complexityCoefficient" placeholder="请输入工程复杂程度调整系数" style="width: 320px;"></t-input>

              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible2">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>
            <t-form-item name="additionalAdjustments" class="form-item-left">
              <span slot="label">
                附加调整
              </span>
              <t-input v-model="formData.additionalAdjustments" placeholder="请输入附加调整" style="width: 320px;"></t-input>
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible3">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item label="作业准备费比例" name="preparationExpenseRate">
              <t-input v-model="preparationExpenseRate" placeholder="" suffix="%"></t-input>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>按照工程勘察收费基准价的15%~20%计算收费</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明

                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="浮动幅度" name="floatingRange">
              <t-input-number v-model="floatingRange" placeholder="" suffix="%" :status="inputStatus3" :tips="tips3" :min="0" theme="normal" />
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>国家标准:80%~120%</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明

                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal"/>
 
            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">提交结果</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item name="subtotal" class="form-item-left">
              <span slot="label">
                收费基价
              </span>
              <t-input v-model="formData.subtotal" placeholder="" disabled style="width: 320px;" suffix="元"></t-input>
            </t-form-item>

            <t-form-item label="基本收费" name="standardPrice">
              <t-input v-model="formData.standardPrice" placeholder="" disabled style="width: 320px;"
                suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="基  准 价" name="standardPrice">
              <t-input v-model="formData.standardPrice" placeholder="" disabled style="width: 320px;"
                suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="作业准备费" name="preparationExpense">
              <t-input v-model="formData.preparationExpense" placeholder="" disabled style="width: 320px;"
                suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="勘察费" name="surveyFees">
              <t-input v-model="formData.surveyFees" placeholder="" disabled style="width: 320px;" suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>

            <t-form-item label="折后勘察费" name="result">
              <t-input v-model="formData.result" placeholder="" disabled style="width: 320px;" suffix="元"
                @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled style="width: 320px;"></t-input>
            </t-form-item>
            <!-- <t-button class="download" @click="downLoad" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button> -->
              <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>


      </t-form>
    </div>

    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>设计服务费计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;">{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>

    <t-dialog placement="center" :visible="visible4" :footer="false" :onConfirm="close4" :onClose="close4"
      class="dialog4">
      <span slot="header">
        工作比例表
        <div class="closeButton" @click="close4"></div>
      </span>

      <t-tabs v-model="value">
        <!-- 默认插槽 和 具名插槽（panel）都是用来渲染面板内容 -->
        <t-tab-panel value="first" label="水电、潮汐" :destroyOnHide="false">
          <t-radio-group v-model="value4" @change="onChange4">
            <t-radio value="初步设计(%)-60">60 <span>初步设计(%)</span></t-radio>
            <t-radio value="招标设计(%)-10">10 <span>招标设计(%)</span></t-radio>
            <t-radio value="施工图设计(%)-30">30 <span>施工图设计(%)</span></t-radio>
          </t-radio-group>
        </t-tab-panel>
        <t-tab-panel value="second" label="水库" :destroyOnHide="false">
          <t-radio-group v-model="value4" @change="onChange4">
            <t-radio value="初步设计(%)-68">68 <span>初步设计(%)</span></t-radio>
            <t-radio value="招标设计(%)-4">4 <span>招标设计(%)</span></t-radio>
            <t-radio value="施工图设计(%)-28">28 <span>施工图设计(%)</span></t-radio>
          </t-radio-group>
        </t-tab-panel>
        <t-tab-panel value="third" label="引调水河道(建筑物)" :destroyOnHide="false">
          <t-radio-group v-model="value4" @change="onChange4">
            <t-radio value="初步设计(%)-68">68 <span>初步设计(%)</span></t-radio>
            <t-radio value="招标设计(%)-4">4 <span>招标设计(%)</span></t-radio>
            <t-radio value="施工图设计(%)-28">28 <span>施工图设计(%)</span></t-radio>
          </t-radio-group>
        </t-tab-panel>
        <t-tab-panel value="fourth" label="引调水河道(渠道管线)" :destroyOnHide="false">
          <t-radio-group v-model="value4" @change="onChange4">
            <t-radio value="初步设计(%)-73">73 <span>初步设计(%)</span></t-radio>
            <t-radio value="招标设计(%)-3">3 <span>招标设计(%)</span></t-radio>
            <t-radio value="施工图设计(%)-24">24 <span>施工图设计(%)</span></t-radio>
          </t-radio-group>
        </t-tab-panel>
        <t-tab-panel value="fifth" label="水土保持" :destroyOnHide="false">
          <t-radio-group v-model="value4" @change="onChange4">
            <t-radio value="初步设计(%)-73">73 <span>初步设计(%)</span></t-radio>
            <t-radio value="招标设计(%)-3">3 <span>招标设计(%)</span></t-radio>
            <t-radio value="施工图设计(%)-24">24 <span>施工图设计(%)</span></t-radio>
          </t-radio-group>
        </t-tab-panel>
      </t-tabs>




    </t-dialog>


    <t-dialog placement="center" :visible="visible1" :footer="false" :onConfirm="close1" :onClose="close1"
      class="dialogdomainCoefficient">
      <span slot="header">
        专业调整系数
        <div class="closeButton" @click="close1"></div>
      </span>


      <t-radio-group v-model="value1" @change="onChange1">
        <t-radio value="水电-1.40">水电 <span>1.40</span></t-radio>
        <t-radio value="水库-1.04">水库 <span>1.04</span></t-radio>
        <t-radio value="潮汐发电-1.70">潮汐发电 <span>1.70</span></t-radio>
        <t-radio value="水士保持(0.5~0.55)-0.525">水士保持(0.5~0.55) <span>0.525</span></t-radio>
        <t-radio value="引导水和河道治理-0.8">引导水和河道治理 <span>0.8</span></t-radio>
        <t-radio value="灌区田间(0.3~0.4)-0.35">灌区田间(0.3~0.4) <span>0.35</span></t-radio>
        <t-radio value="城市防护、河口整治(0.84~0.92)-0.88">城市防护、河口整治(0.84~0.92) <span>0.88</span></t-radio>
        <t-radio value="围垦(0.76~0.88)-0.82">围垦(0.76~0.88) <span>0.82</span></t-radio>
      </t-radio-group>


    </t-dialog>

    <t-dialog placement="center" :visible="visible2" :footer="false" :onConfirm="close2" :onClose="close2"
      class="dialog2">
      <span slot="header">
        工程复杂程度调整系数
        <div class="closeButton" @click="close2"></div>
      </span>
      <t-form style="    padding: 0 25%;
    margin-top: 20px;">
        <t-form-item label="工程类型" name="complexityCoefficient">
          <t-cascader class="custom-cascader-1" :options="complexityCoefficientList" clearable key="id"
            :keys="{ value: 'id', label: 'name', children: 'children' }"
            @change="changecomplexityCoefficient"></t-cascader>
        </t-form-item></t-form>
      <p>复杂程序</p>
      <t-space>
        <t-radio-group v-model="value2" @change="onChange2">
          <t-radio :value="item.name" v-for="item in this.complexityRadioGroupList" :key="item.id">
            {{ item.name }} <span></span>

          </t-radio>
 
        </t-radio-group>
      </t-space>
      <template>

        <t-table class="complexity-table" bordered row-key="id" :data="this.complexityRadioGroupList"
          :columns="complexitycolumns">
          <template #name="{ row }">
            <!-- 在此处通过 v-html 显示 HTML 内容 -->
            <div>{{ row.name.split('-')[0] }}</div>
          </template>
          <template #features="{ row }">
            <!-- 在此处通过 v-html 显示 HTML 内容 -->
            <div v-html="row.features"></div>

          </template>
        </t-table>
      </template>


    </t-dialog>

    <t-dialog placement="center" :visible="visible5" :footer="false" :onConfirm="close5" :onClose="close5"
      class="dialog5">
      <span slot="header">
        复杂程度赋分
        <div class="closeButton" @click="close5"></div>
      </span>
      <p>坝高</p>
      <t-space>
        <t-radio-group v-model="value51" @change="onChange51">
          <t-radio value="-5">H&lt;30 <span>-5</span></t-radio>
          <t-radio value="-2">30=&lt;H&lt;50 <span>-2</span></t-radio>
          <t-radio value="1">50=&lt;H&lt;70 <span>1</span></t-radio>
          <t-radio value="3">70=&lt;H&lt;150 <span>3</span></t-radio>
          <t-radio value="3">150=&lt;H&lt;250 <span>5</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>建筑物</p>

      <t-radio-group v-model="value52" @change="onChange51">
        <t-space style="margin-bottom:0;margin: 0 auto;">
          <t-radio value="-1">冶炼工程 <span>-1</span></t-radio>
          <t-radio value="1">常规重力坝 <span>1</span></t-radio>
          <t-radio value="2">两种坝型或引水线路大于3Km或者抽水蓄能电站 <span>2</span></t-radio>
        </t-space>
        <t-space style="margin-bottom:0;margin: 0 auto;">
          <t-radio value="3">拱坝、碾压混凝土坝、混凝土面板堆石坝、新坝型 <span>3</span></t-radio>
          <t-radio value="4">大型地下洞室群 <span>4</span></t-radio>
        </t-space>
      </t-radio-group>

      <p>岩石级别</p>
      <t-space>
        <t-radio-group v-model="value53" @change="onChange51">
          <t-radio value="-2">V级以下 <span>-2</span></t-radio>
          <t-radio value="0">VI级岩石 <span>0</span></t-radio>
          <t-radio value="1">VII级岩石 <span>1</span></t-radio>
          <t-radio value="2">VIll、IX级岩石 <span>2</span></t-radio>
          <t-radio value="3">X级以上 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>地形面貌</p>
      <t-space>
        <t-radio-group v-model="value54" @change="onChange51">
          <t-radio value="-2">简单 <span>-2</span></t-radio>
          <t-radio value="1">中等 <span>1</span></t-radio>
          <t-radio value="2">较复杂 <span>2</span></t-radio>
          <t-radio value="3">复杂 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>

      <p>底层岩性</p>

      <t-radio-group v-model="value55" @change="onChange51">

        <t-radio value="-2">均一 <span>-2</span></t-radio>
        <t-radio value="1">较均一 <span>1</span></t-radio>
        <t-radio value="2">较复杂 <span>2</span></t-radio>
        <t-radio value="3">复杂 <span>3</span></t-radio>

      </t-radio-group>

      <p>地质构造</p>
      <t-space>
        <t-radio-group v-model="value56" @change="onChange51">
          <t-radio value="-2">简单 <span>-2</span></t-radio>
          <t-radio value="1">中等 <span>1</span></t-radio>
          <t-radio value="2">较复杂 <span>2</span></t-radio>
          <t-radio value="3">复杂 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>坝基或厂基覆盖层厚度</p>
      <t-space>
        <t-radio-group v-model="value57" @change="onChange51">
          <t-radio value="-2">&lt;10m <span>-2</span></t-radio>
          <t-radio value="1">10~20m <span>1</span></t-radio>
          <t-radio value="2">20~40m <span>2</span></t-radio>
          <t-radio value="4">40~60m <span>4</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>人文地质</p>
      <t-space>
        <t-radio-group v-model="value58" @change="onChange51">
          <t-radio value="-2">简单 <span>-2</span></t-radio>
          <t-radio value="1">中等 <span>1</span></t-radio>
          <t-radio value="2">较复杂 <span>2</span></t-radio>
          <t-radio value="3">复杂 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>库岸稳定</p>

      <t-radio-group v-model="value59" @change="onChange51">
        <t-space style="margin-bottom:0;margin: 0 auto;">
          <t-radio value="0">可能不稳定体&lt;10万m³ <span>0</span></t-radio>
          <t-radio value="2">可能不稳定体10万~100万m³ <span>2</span></t-radio>
        </t-space>
        <t-space style="margin-bottom:0;margin: 0 auto;">
          <t-radio value="3">可能不稳定体100万~500万m³ <span>3</span></t-radio>
          <t-radio value="4">可能不稳定体500万m³以上 <span>4</span></t-radio>
        </t-space>
      </t-radio-group>

      <p>库区渗漏</p>
      <t-space>
        <t-radio-group v-model="value60" @change="onChange51">
          <t-radio value="-1">无永久性渗漏 <span>-1</span></t-radio>
          <t-radio value="2">断层或古河道渗漏 <span>2</span></t-radio>
          <t-radio value="3">单薄分水岭渗漏 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>人文勘察</p>
      <t-space>
        <t-radio-group v-model="value61" @change="onChange51">
          <t-radio value="-1">简单 <span>-1</span></t-radio>
          <t-radio value="1">中等 <span>1</span></t-radio>
          <t-radio value="3">复杂 <span>3</span></t-radio>
        </t-radio-group>
      </t-space>
    </t-dialog>

    <t-dialog placement="center" :visible="visible3" :footer="false" :onConfirm="close3" :onClose="close3"
      class="dialog3">
      <span slot="header">
        附加调整系数
        <div class="closeButton" @click="close3"></div>
      </span>

      <t-radio-group v-model="value3" @change="onChange3">

        <t-radio value="坝址或坝线比较(一个或者一条)-0.7">坝址或坝线比较(一个或者一条) <span>0.7</span></t-radio>
        <t-radio value="坝址或坝线比较(三个或者三条)-1.3">坝址或坝线比较(三个或者三条) <span>1.3</span></t-radio>
        <t-radio value="引水线路比较(两条以上)-1.2">引水线路比较(两条以上) <span>1.2</span></t-radio>
        <t-radio value="岩溶地区(岩溶地区勘察)-1.2">岩溶地区(岩溶地区勘察) <span>1.2</span></t-radio>
        <t-radio value="河床覆盖层厚度(>60m)-1.1">河床覆盖层厚度(>60m) <span>1.1</span></t-radio>
        <t-radio value="地震设防烈度(>=8度取值范围:1.1~1.2)-1.15">地震设防烈度(>=8度取值范围:1.1~1.2) <span>1.15</span></t-radio>
        <t-radio value="深埋长隧道(埋深>1000m,长度>8km)-1.2">深埋长隧道(埋深>1000m,长度>8km) <span>1.2</span></t-radio>
        <t-radio value="线路勘察(两条以上取值范围:1.05~1.5)-1.275">线路勘察(两条以上取值范围:1.05~1.5) <span>1.275</span></t-radio>

      </t-radio-group>


    </t-dialog>
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { getslsdgc } from '@/api/data'
import { listRate } from "@/api/rate";
import { listFile } from "@/api/file";

export default {
  name: 'slsdgcFee',
  components: {

  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl: null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        domainCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],

        elevationCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        otherDesign: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }]
      },
      helpOpen: false,
      downData: {},
      value: 'first',
      value1: '',
      visible1: false,
      value2: '',
      visible2: false,
      value3: '',
      visible3: false,
      value4: '',
      visible4: false,
      visible5: false,
      value51: '-5',
      value52: '-1',
      value53: '-2',
      value54: '-2',
      value55: '-2',
      value56: '-2',
      value57: '-2',
      value58: '-2',
      value59: '0',
      value60: '-1',
      value61: '-1',
      discountRate: null,

      scheduleProportion: '100',
      floatingRange: '80',
      preparationExpenseRate: '17.5',
      formData: {
        projectName: '',
        ificationId: this.$route.query.ification,
        money: null,
        scheduleProportion: null, // 比例表
        adjustmentCoefficient: '1.0',// 专业调整系数
        scoreAssignmentTable: null,// 赋分表
        complexCoefficient: null,//复杂程度
        additionalAdjustments: '1.0',// 附加调整
        preparationExpenseRate: null,//作业准备费比例
        floatingRate: null,//浮动幅度
        discountRate: 0,

        subtotal: null, //收费基价
        standardPrice: null,// 基准价
        preparationExpense: null,// 作业准备费
        surveyFees: null,// 勘察费
        result: null,//折后勘察费

        // domainCoefficientName:null,//专业调整系数名称
        // domainCoefficient: null,//专业调整系数
        // complexityCoefficientName:null,//工程复杂程度调整系数名称
        // complexityCoefficient: null,//工程复杂程度调整系数
        // elevationCoefficientName:null,
        // elevationCoefficient: null,//高程调整系数
        // standardPrice: null,//施工监理服务收费基准价

        discountRateMoney: null,

      },
      resultChinese: '',
      fileList: [],
      complexityCoefficientList: [],
      complexityList: [
        {
          id: '1',
          name: '水库、水电工程',
          parentId: '0'
        },
        {
          id: '2',
          name: 'Ⅰ级',
          parentId: 1,
          features: '赋分值之和<=-3'
        },
        {
          id: '3',
          name: 'Ⅱ级',
          parentId: '1',
          features: '赋分值之和-3~10'
        },
        {
          id: '4',
          name: 'Ⅲ级',
          parentId: '1',
          features: '赋分值之和>=10'
        },
        {
          id: '5',
          name: '引调水建筑物工程',
          parentId: '0'
        },
        {
          id: '6',
          name: 'Ⅰ级',
          parentId: '5',
          features: '丘陵、山区、沙漠地区建筑物投资之和占全部建筑物的总投资<=30%'
        },
        {
          id: '7',
          name: 'Ⅱ级',
          parentId: '5',
          features: '丘陵、山区、沙漠地区建筑物投资之和占全部建筑物的总投资<=60%'
        },
        {
          id: '8',
          name: 'Ⅲ级',
          parentId: '5',
          features: '丘陵、山区、沙漠地区建筑物投资之和占全部建筑物的总投资>60%'
        },
        {
          id: '9',
          name: '引调水渠道管线工程',
          parentId: '0'
        },
        {
          id: '10',
          name: 'Ⅰ级',
          parentId: '9',
          features: '丘陵、山区、沙漠地区渠道管线长度之和占总长度的<=30%'
        },
        {
          id: '11',
          name: 'Ⅱ级',
          parentId: '9',
          features: '丘陵、山区、沙漠地区渠道管线长度之和占总长度的<=60%'
        },
        {
          id: '12',
          name: 'Ⅲ级',
          parentId: '9',
          features: '丘陵、山区、沙漠地区渠道管线长度之和占总长度的>60%'
        },
        {
          id: '13',
          name: '河道治理建筑物及河道堤防工程',
          parentId: '0'
        },
        {
          id: '14',
          name: 'Ⅰ级',
          parentId: '13',
          features: '堤防等级V级'
        },
        {
          id: '15',
          name: 'Ⅱ级',
          parentId: '13',
          features: '堤防等级Ill、IV级'
        },
        {
          id: '16',
          name: 'Ⅲ级',
          parentId: '13',
          features: '堤防等级1、II级'
        },
        {
          id: '17',
          name: '其他',
          parentId: '0'
        },
        {
          id: '18',
          name: 'Ⅱ级',
          parentId: '17',
          features: '灌区田间工程、水士保持工程'
        }



      ],
      complexityRadioGroupList: [],
      complexityRemark: null,
      complexityCoefficient: 'Ⅰ级',
      data: [{

      }],
      columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '收费基价（万元）',
          colKey: 'rate',
          width: 100,
        }

      ],
      complexitycolumns: [
        {
          title: '等级',
          colKey: 'name',
          width: 50,
        },
        {
          title: '工程特征',
          colKey: 'features',
          width: 180,
        }

      ],
      calculateRange: null,//计算范围
      calculationFormula: null // 计算公式

    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        this.fileList = response.rows[0];

      });

      this.complexityCoefficientList = []
      this.complexityList.forEach(item => {
        if (item.parentId == 0) {
          this.complexityCoefficientList.push(item)
        }
      })

      listRate({ ificationId: this.$route.query.ification }).then(res => {
        let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999) {
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows

      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if (res.data.scope) {
          if (res.data.scope.indexOf("\\n") != -1) {
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          } else {
            this.calculateRange = res.data.scope
          }

        } else {
          this.calculateRange = '暂无数据'
        }
        if (res.data.particulars) {
          if (res.data.particulars.indexOf("\\n") != -1) {
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          } else {
            this.calculationFormula = res.data.particulars
          }
        } else {
          this.calculationFormula = '暂无数据'
        }
      })
      this.sumscoreAssignment()
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    handleClear() {
      this.helpOpen = true
    },




    submit() {
      switch (this.complexityCoefficient) {
        case 'Ⅰ级':
          this.formData.complexCoefficient = 0.85;
          break;
        case 'Ⅱ级':
          this.formData.complexCoefficient = 1.0;
          break;
        case 'Ⅲ级':
          this.formData.complexCoefficient = 1.15;
          break;
      }
      // console.log(111)

      this.formData.scheduleProportion = Number(this.scheduleProportion) / 100
      this.formData.floatingRate = Number(this.floatingRange) / 100
      this.formData.discountRate = Number(this.discountRate) / 100
      this.formData.preparationExpenseRate = Number(this.preparationExpenseRate) / 100

      getslsdgc(this.formData).then(res => {
        this.downData = res.data
        this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        this.formData.standardPrice = res.data.standardPrice.toFixed(2).toString()
        this.formData.preparationExpense = res.data.preparationExpense.toFixed(2).toString()
        this.formData.surveyFees = res.data.surveyFees.toFixed(2).toString()
        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        this.jsgc = res.data.jsgc
      })

    }, 
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'工程造价:' + this.formData.money + '（万元）;' + `比例表:${this.scheduleProportion}%;专业调整:${this.formData.adjustmentCoefficient};赋分表:${this.formData.scoreAssignmentTable};复杂程度:${this.complexityCoefficient};附加调整:${this.formData.additionalAdjustments};作业准备费比例:${this.preparationExpenseRate}%;浮动幅度:${this.floatingRange}%;折扣率:${this.discountRate}%。`,
        yjwj:this.fileList ? this.fileList.fileName.split('.')[0] : '--',
       fzcdtzxs:this.complexityCoefficient,
       gcxs:this.formData.adjustmentCoefficient,
       fjtzxs:this.formData.additionalAdjustments,
       blbxs:this.scheduleProportion + '%',
       kczyzbfv:this.preparationExpenseRate+ '%',
        jsgc:this.jsgc,
        fulx:'水利水电工程勘察费',
        zhj:this.formData.result,
      }
      this.download('/project/slsdkc/word', { id: this.downData.id, classId: 50,...wordParam }
        , `勘察费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    openVisible1() {
      this.visible1 = true
    },
    close1() {
      this.visible1 = false;
    },
    onChange1(checkedValues) {

      // this.formData.domainCoefficientName = checkedValues.split('-')[0].toString()
      this.formData.adjustmentCoefficient = checkedValues.split('-').slice(-1).toString()
    },
    openVisible2() {
      this.visible2 = true
    },
    close2() {
      this.visible2 = false;
    },
    onChange2(checkedValues) {
      this.complexityCoefficient = checkedValues
    },
    openVisible3() {
      this.visible3 = true
    },
    close3() {
      this.visible3 = false;
    },
    onChange3(checkedValues) {
      // console.log('checkedValues:', this.value3, checkedValues.split('=').slice(-1));
      this.formData.additionalAdjustments = checkedValues.split('-').slice(-1).toString()


    },
    openVisible4() {
      this.visible4 = true
    },
    close4() {
      this.visible4 = false;
    },
    onChange4(checkedValues) {

      // this.formData.domainCoefficientName = checkedValues.split('-')[0].toString()
      this.scheduleProportion = checkedValues.split('-').slice(-1).toString()
      // this.formData.scheduleProportion = checkedValues.split('-').slice(-1).toString()
    },
    openVisible5() {
      this.visible5 = true
    },
    close5() {
      this.visible5 = false;
    },
    onChange51() {
      this.sumscoreAssignment()
    },
    sumscoreAssignment() {
      this.formData.scoreAssignmentTable = String(Number(this.value51) + Number(this.value52) + Number(this.value53) + Number(this.value54) + Number(this.value55) + Number(this.value56) + Number(this.value57) + Number(this.value57) + Number(this.value58) + Number(this.value59) + Number(this.value60) + Number(this.value61))
      // console.log(this.formData.scoreAssignmentTable)
    },
    changecomplexityCoefficient(val, context) {
      this.complexityRadioGroupList = []
      // console.log( val, context);
      // console.log('path: ', context.node.getPath());
      // this.formData.complexityCoefficientName = context.node.data.name
      this.complexityRemark = context.node.data.remark
      // console.log(this.complexityRemark)
      // this.formData.complexityCoefficient = context.node.data.name
      this.complexityList.forEach((item) => {
        if (item.parentId == val) {
          this.complexityRadioGroupList.push(item)
        }
      })
      // console.log(this.complexityRadioGroupList)

    },
    fileOpenDialog(url) {
      this.downFileUrl = url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }
  },
  computed: {
    inputStatus3() {
      if (this.floatingRange < 80 || this.floatingRange > 120) {
        return 'error';
      }
      return '';
    },
    tips3() {
      if (!this.inputStatus3) {
        return '';
      }
      return '超出国定范围';
    },
  }
}
</script>

<style lang="less">
.slsdgc {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;



  

  .dialogdomainCoefficient {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 202px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        .t-radio-group {
          display: block !important;
          margin: 0 auto;
          margin-top: 10px;
        }

        .t-radio {
          display: block;
          width: 260px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 8px !important;
        }


        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 30px;
          letter-spacing: -0.01px;
          margin-bottom: 8px !important;
          width: 230px;

          span {
            color: #000000;
            float: right;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }

  .dialog2 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;


      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');

        padding: 0;

        .t-form__label {
          height: 32px;
          line-height: 32px;
          font-family: "Regular";
        }

        .custom-cascader-1 {
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }

        .complexity-table {
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }

  .dialog3 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 602px;
      height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');


        .t-radio-group {
          display: block;
          margin-top: 15px;
          margin: 0 auto;
          text-align: left;
          margin-top: 15px;
          padding-left: 80px;

          .t-radio {
            width: 310px;
            display: block;
            margin-bottom: 10px;
          }
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }
      }
    }
  }

  .dialog4 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 702px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        .t-tabs {
          background: url('@/assets/dialog-background.png');
        }

        .t-radio-group {
          display: block;
          margin: 0 auto;
          margin-top: 10px;

          .t-radio {
            display: block;
            width: 140px;
            margin-bottom: 15px;
            text-align: left;

          }
        }


        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }

  .dialog5 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 902px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 8px !important;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }


}
</style>
